import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const wrapContent = () => {
  const content = document.querySelector('.our-story-content')

  content.querySelectorAll('p').forEach((p) => {
    p.innerHTML = `<span>${p.innerHTML}</span>`
  })
}

const setupReveal = () => {
  const content = document.querySelector('.our-story-content')
  const paragraphs = content.querySelectorAll('p')

  gsap.set(paragraphs, {
    opacity: 0,
  })

  gsap.to(paragraphs, {
    opacity: 1,
    duration: 1.5,
    stagger: 0.5,
    paused: true,
    ease: 'linear',
    scrollTrigger: {
      trigger: content,
      start: 'top 60%',
      markers: false,
    },
  })
}

export default {
  can: () => document.body.classList.contains('pagetype-ourstorypage'),
  run: () => {
    wrapContent()
    setupReveal()
  },
}
